"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 15.401V6.095l1.713 4.036 4.383.378-3.322 2.884.993 4.281L12 15.401zM18.18 21l-1.63-7.03L22 9.24l-7.19-.62L12 2v15.27L18.18 21z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;